var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "product-item" }, [
    _c(
      "a",
      {
        staticClass: "product-item__image-wrapper",
        staticStyle: { "--aspect-ratio": "0.75" },
        attrs: {
          href: _vm.url,
          title: `Product: ${_vm.title}`,
          "aria-label": `Product: ${_vm.title}`,
        },
        on: {
          mouseover: function ($event) {
            _vm.hover = _vm.$screen.laptop_up
          },
          mouseleave: function ($event) {
            _vm.hover = false
          },
        },
      },
      [
        _c(
          "transition",
          { attrs: { name: "fade" } },
          [
            _c("VImg", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.activeImage,
                  expression: "activeImage",
                },
              ],
              key: _vm.key,
              staticClass: "product-item__main-img",
              attrs: {
                media: _vm.activeImage,
                fixedSize: _vm.imageSize,
                customClass: {
                  lazyload: _vm.hover,
                  "remove-transition": _vm.lazyloaded,
                },
              },
              on: {
                loaded: function ($event) {
                  _vm.lazyloaded += 1
                },
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _vm.hoverImage
          ? _c("VImg", {
              key: _vm.key,
              staticClass: "product-item__hover-img",
              attrs: {
                media: _vm.hoverImage,
                fixedSize: _vm.imageSize,
                customClass: {
                  hovering: _vm.hover,
                  "remove-transition": _vm.lazyloaded,
                },
              },
              on: {
                loaded: function ($event) {
                  _vm.lazyloaded += 1
                },
              },
            })
          : _vm._e(),
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "product-item__details" }, [
      _c("p", {
        staticClass: "h5 product-item__title",
        domProps: { textContent: _vm._s(_vm.title) },
      }),
      _vm._v(" "),
      _c("p", {
        staticClass: "h6 product-item__vendor",
        domProps: { textContent: _vm._s(_vm.product.vendor) },
      }),
      _vm._v(" "),
      _c("p", { staticClass: "h6 product-item__price" }, [
        _c("span", {
          domProps: { textContent: _vm._s(_vm.$money(_vm.price)) },
        }),
        _vm._v(" "),
        _vm.salePrice
          ? _c("s", {
              staticClass: "price--sale",
              domProps: { textContent: _vm._s(_vm.$money(_vm.salePrice)) },
            })
          : _vm._e(),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }